export default {
    invitationEmail: false,
};
